import { CACHE_IMAGE, CACHE_ALL_IMAGES, PURGE_IMAGE } from '../constants/ActionTypes'

/**
 * @typedef {ReturnType<typeof cacheImage> | ReturnType<typeof purgeImage> | ReturnType<typeof cacheAllImages>} ImageCacheActions
 */

/**
 * @param {String} storageUrl
 * @param {String} publicUrl
 * @return {{ type: 'CACHE_IMAGE', storageUrl: String, publicUrl: String, timestamp: number }}
 */
export const cacheImage = (storageUrl, publicUrl) => ({
  type: CACHE_IMAGE,
  storageUrl,
  publicUrl,
  timestamp: new Date().getTime(),
})

/**
 * @param {Record<String, String>} cache
 * @return {{ type: 'CACHE_ALL_IMAGES', cache: Record<String, String>, timestamp: number }}
 */
export const cacheAllImages = (cache) => {
  return {
    type: CACHE_ALL_IMAGES,
    cache,
    timestamp: new Date().getTime(),
  }
}

/**
 * @param {String} storageUrl
 * @return {{ type: 'PURGE_IMAGE', storageUrl: String }}
 */
export const purgeImage = (storageUrl) => ({
  type: PURGE_IMAGE,
  storageUrl,
})
